export enum Identifier {
    POPULAR_LINKS = 'popular_links',
    CONTACT_US = 'contact_us',
    POLICIES = 'policies',
    STORES = 'stores',
    COPYRIGHT = 'copyright_section',
    SOCIAL_MEDIA = 'social_media',
    SITEMAP = 'sitemap_section',
}